import http from '@axios'

const endpoint = `/user`;

const body = {
  "req": {
    "id": 123342523,
    "time": "2021-08-09T10:11:20+07:00",
    "src": "member-web",
    "op": "login"
  },
  "data": {}
};

const login = (data) => {
  body.req.op="validateUser";
  body.data = data;
  console.log('ini login',body);
  return http.post(endpoint, body);
}

export { login }
